import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import "../../style/controls/presetSelector.scss";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { SameSectionAccordion } from "@devowl-wp/customize";
import { waitObject } from "@devowl-wp/react-utils";
import { CustomizePresetCard } from "./presetCard.js";
import { BannerPreset } from "../../models/bannerPreset.js";
import { useStores } from "../../store/stores.js";
import { __ } from "../../utils/i18n.js";
const INTERVAL_SWITCH_INDIVIDUAL_PRIVACY_SECONDS = 5;
const CustomizePresetSelector = observer(()=>{
    const [open, setOpen] = useState(false);
    const [fetched, setFetched] = useState(false);
    const { customizeBannerStore } = useStores();
    const { busyPresets, presets } = customizeBannerStore;
    const handleToggle = (state)=>{
        if (state && !fetched) {
            customizeBannerStore.fetchPresets();
            setFetched(true);
        }
        setOpen(state);
    };
    const handleApply = ()=>{
        handleToggle(false);
    };
    // Also, allow autofocus by a customAutofocus (this is not a standard!)
    useEffect(()=>{
        if (window.location.href.indexOf("customAutofocus[rcb-presets]=1") > -1) {
            // We need to wait for the iframe so the presets can be applied to the cookie banner
            waitObject(()=>BannerPreset.getIframeStore()).then(()=>handleToggle(true));
        }
    }, []);
    return /*#__PURE__*/ _jsxs(SameSectionAccordion, {
        state: open,
        onToggle: handleToggle,
        title: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("span", {
                    className: busyPresets ? "spinner is-active" : "",
                    style: {
                        margin: 0
                    }
                }),
                " ",
                __("Presets")
            ]
        }),
        grouped: true,
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: "description",
                children: __("You can choose between different presets. Presets only change the style, but no texts or content. Tip: Hover the mouse over a preset to see a real-time preview. Wait %d seconds, and you will see a preview of the individual privacy settings screen.", INTERVAL_SWITCH_INDIVIDUAL_PRIVACY_SECONDS)
            }),
            /*#__PURE__*/ _jsx("br", {}),
            Array.from(presets.values()).map((preset)=>/*#__PURE__*/ _jsx(CustomizePresetCard, {
                    preset: preset,
                    onApply: handleApply
                }, preset.id))
        ]
    });
});
export { INTERVAL_SWITCH_INDIVIDUAL_PRIVACY_SECONDS, CustomizePresetSelector };
